import { useActiveMediaQuery } from '@stepstone-genesis/hooks-use-active-media-query';
export const useMobile = () => {
    const { matches } = useActiveMediaQuery({
        breakpoints: [600, 900, 1200, 1800],
        keys: ['xs', 'small', 'medium', 'large', 'xl'],
    });
    return matches.xs ?? false;
};
//# sourceMappingURL=useMobile.js.map